import React from "react";
import { verifyPermission } from "helpers/permission";
import HeaderTablePage from "views/components/HeaderTablePage";
import InfirmationTable from "views/components/InfirmationTable";

export const PermissionGuard = ({ userPermissions, children, t }) => {
  const hasUpdatePermission = verifyPermission(
    userPermissions,
    "update-configuration-quota-delay"
  );
  const hasShowPermission = verifyPermission(
    userPermissions,
    "show-configuration-quota-delay"
  );

  if (!hasUpdatePermission && !hasShowPermission) {
    return (
      <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
        <InfirmationTable
          information={t("Configuration du quota des délais")}
        />
        <div className="kt-portlet">
          <HeaderTablePage title={t("Quota des délais")} />
        </div>
        <h1>{t("Vous ne pouvez pas effectuer cette opération")}</h1>
      </div>
    );
  }

  return children;
};
